module.exports = __webpack_public_path__ + "static/media/pin.65cd6ee4.svg";